import CoursesIcon from '~/shared/assets/courses.icon.svg';
// import DashboardIcon from '~/shared/assets/dashboard.icon.svg';
import HelpIconSvg from '~/shared/assets/help.icon.svg';
import ImportCourseIcon from '~/shared/assets/import.icon.svg';
import StatisticsIcon from '~/shared/assets/statistics.icon.svg';
import StudentsIcon from '~/shared/assets/students.icon.svg';
import TemplatesIcon from '~/shared/assets/templates.icon.svg';

import { routes } from '../routes';

import { NavigationLink } from './navigation-link.type';

export const teacherNavigationLinks: NavigationLink[] = [
  // {
  //   to: routes.dashboard.get(),
  //   linkText: 'Dashboard',
  //   icon: <DashboardIcon />,
  // },
  {
    to: routes.dashboard.courses.get(),
    linkText: 'My courses',
    icon: <CoursesIcon />,
  },
  {
    to: routes.underConstruction.get(),
    linkText: 'Course statistics',
    icon: <StatisticsIcon />,
  },
  {
    to: routes.underConstruction.get(),
    linkText: 'Templates',
    icon: <TemplatesIcon />,
  },
  {
    to: routes.underConstruction.get(),
    linkText: 'Students',
    icon: <StudentsIcon />,
  },
  // Todo uncomment when students endpoints will be finished
  // {
  //   to: routes.dashboard.students.get(),
  //   linkText: 'Students',
  //   icon: <StudentsIcon />,
  // },
  {
    to: routes.underConstruction.get(),
    linkText: 'Import course',
    icon: <ImportCourseIcon />,
  },
  {
    // to: routes.dashboard.support.get(),
    to: routes.dashboard.support.get(),
    linkText: 'Support',
    icon: <HelpIconSvg />,
  },
];
